import { network } from "../config";
import {
  CreateHubForUserPayload,
  EducationalHub,
  TypeEducationalHubFilters,
} from "../types/EducationalHub";
import TypeDefaultResponse from "../types/TypeDefaultResponse";
import { TypeUpdatedUserInfo } from "../types/TypeUsers";
import url from "../utils/formApiUrl";
import customKy from "./kyExtend";

const { educationalHub } = network;

const baseURL =
  process.env.REACT_APP_HTTP_CONNECTION_STRING + "educational-hub/";

const getAuthHeader = (token: string) => {
  return { Authorization: `Bearer ${token}` };
};

export default class EducationalHubApi {
  static async updateHub(
    token: string,
    updateData: TypeUpdatedUserInfo,
  ): Promise<
    TypeDefaultResponse & {
      hubs?: EducationalHub[];
    }
  > {
    return await customKy
      .patch(url(baseURL, educationalHub.updateHub, { id: updateData.id }), {
        headers: getAuthHeader(token),
        json: updateData,
      })
      .then((res) => res.json());
  }

  static async getUnapprovedHubs(
    token: string,
    payload: {
      page: number;
      limit: number;
    },
  ): Promise<
    TypeDefaultResponse & {
      hubs?: EducationalHub[];
    }
  > {
    return await customKy
      .get(
        url(baseURL, educationalHub.getUnapprovedHubs, {
          page: payload.page,
          limit: payload.limit,
        }),
        {
          headers: getAuthHeader(token),
        },
      )
      .then((res) => res.json());
  }

  static async getHubFileSignedUrl(
    token: string,
    filepath: string,
  ): Promise<TypeDefaultResponse & { url?: string }> {
    const params = new URLSearchParams();
    if (filepath) {
      params.append("filepath", filepath);
    }
    return await customKy
      .get(url(baseURL, educationalHub.getHubFileSignedUrl, {}, params), {
        headers: getAuthHeader(token),
      })
      .then((res) => res.json());
  }

  static async createHubForUserByAdmin(
    token: string,
    payload: CreateHubForUserPayload,
  ): Promise<
    TypeDefaultResponse & {
      hub?: EducationalHub;
    }
  > {
    return await customKy
      .post(url(baseURL, educationalHub.createHubForUserByAdmin), {
        headers: getAuthHeader(token),
        json: payload,
      })
      .then((res) => res.json());
  }

  static async getFilteredHubs(
    token: string,
    filters: TypeEducationalHubFilters,
  ): Promise<
    TypeDefaultResponse & {
      hubs?: EducationalHub[];
      totalAmount?: number;
    }
  > {
    return await customKy
      .post(url(baseURL, educationalHub.getFilteredHubs), {
        headers: getAuthHeader(token),
        json: { filters },
      })
      .then((res) => res.json());
  }
}
